import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginDto } from 'app/modules/auth/services/payloads/login.dto';
import { phoneValidator } from '../../../../shared/validators/phone.validator';

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  @Input() isLoading: boolean;
  @Output() onSubmit: EventEmitter<LoginDto>;

  constructor(private fb: FormBuilder) {
    this.onSubmit = new EventEmitter();
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      contact: [null, [Validators.required, phoneValidator]],
      password: [null, Validators.required],
    });
  }

  submit() {
    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.onSubmit.emit(this.loginForm.value);
  }

  get f() {
    return this.loginForm.controls;
  }
}
